import React, { Component } from "react";
import { DropdownButton, MenuItem, Modal, Radio } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import Loading from "../../../components/Loading";
import * as Business from "../../../utils/business";
import "./processing.style.scss";
import * as Http from "../../../http";
import { get } from "lodash";

const fmtN = (v) =>
  v !== null && v !== undefined && v !== ""
    ? Number(String(v).replace(/,/g, "")).toLocaleString("en-US")
    : "";
const parseN = (s) => String(s).replace(/[^0-9]/g, "");

const dicSearchOptions = {
  customer_name: "Customer name",
  id: "ID",
};

const partyTypeOptions = [
  { label: "Enterprise", value: "enterprise" },
  { label: "Individual", value: "individual" },
  { label: "Financial Institution", value: "financial_institution" },
];

class RetailTable extends Component {
  state = {
    searchOption: "customer_name",
    searchValue: "",
    type: "retail",
    bankType: "",
    items: [],
    openNew: false,
    openForm: false,
    formData: { collateral_currency: "VND", tentative_loan_ccy: "VND" },
    collateralTypeOptions: [],
    productOptions: [],
    customerSearch: "",
    selectedCustomer: null,
  };

  componentDidMount() {
    Http.getListPricing("RETAIL").then((res) => {
      this.setState({ items: res.Data });
    });
    Http.getPricingCollateralMaster().then((res) => {
      const data = res.Data || {};
      const types = Object.values(data).map((col) => ({
        value: col.collateral_type,
        label: col.collateral_type_name,
      }));
      this.setState({ collateralTypeOptions: types });
    });
    Http.getPricingProductMaster().then((res) => {
      const data = res.Data || {};
      const types = Object.values(data)
        .filter((prd) => prd.cust_segment_code === "Retail")
        .map((prd) => ({
          value: prd.product_type,
          label: prd.product_type_name,
        }));
      this.setState({ productOptions: types });
    });
  }

  setFormData = (field, value) => {
    this.setState({ formData: { ...this.state.formData, [field]: value } });
  };

  onDelete({ customer_id, customer_type, process_date }) {
    Http.deletePricingInfo(customer_id, customer_type, process_date)
      .then((res) => {
        return Http.getListPricing("RETAIL");
      })
      .then((res) => {
        this.setState({ items: res.Data });
      });
  }

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      <div className="content table-responsive table-full-width">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
          }}
        >
          <DropdownButton
            title={dicSearchOptions[this.state.searchOption]}
            bsSize="small"
            id={`dropdown-size-${1}`}
          >
            <MenuItem
              onSelect={(eventKey, event) => {
                this.setState({ searchOption: eventKey });
              }}
              eventKey={`customer_name`}
            >
              {"Customer name"}
            </MenuItem>
            <MenuItem divider />
            <MenuItem
              onSelect={(eventKey, event) => {
                this.setState({ searchOption: eventKey });
              }}
              eventKey={`id`}
            >
              {"ID"}
            </MenuItem>
            <MenuItem divider />
          </DropdownButton>
          <input
            type="text"
            style={{ height: "30px", width: "200px" }}
            className="form-control"
            id="search_value"
            onChange={(event) => {
              this.setState({ searchValue: event.target.value });
            }}
          />
          <button
            type="button"
            disabled={this.state.progressValue > 0}
            className="btn btn-primary"
            style={{
              backgroundColor: "#FFE600",
              borderColor: "#7F7E82",
              borderRadius: "3px",
              fontWeight: 600,
              height: "30px",
              lineHeight: "18px",
              fontSize: "10px",
              padding: "0 12px",
              whiteSpace: "nowrap",
            }}
            onClick={() => this.search()}
          >
            Search
          </button>
          <button
            type="button"
            className="btn btn-primary"
            style={{
              backgroundColor: "#FFE600",
              borderColor: "#7F7E82",
              borderRadius: "3px",
              fontWeight: 600,
              marginLeft: "auto",
              height: "30px",
              lineHeight: "18px",
              fontSize: "10px",
              padding: "0 12px",
              whiteSpace: "nowrap",
            }}
            onClick={() => this.setState({ openNew: true })}
          >
            + NEW PRICING
          </button>
        </div>

        <table className="table table-hover table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Customer Name</th>
              <th>Product Type</th>
              <th>Tenor</th>
              <th>Pricing Rate</th>
              <th>Final Offer Rate</th>
              <th>Pricing Time</th>
              <th>Staff</th>
            </tr>
          </thead>
          <tbody>
            {(this.state.items || []).map((item) => {
              const tenor = get(item, "facility_info.tentative_loan_tenor");
              const rate =
                get(item, "result.processing.proposed_interest_rate", 0) * 100;
              return (
                <tr key={item.id}>
                  <td>{item.customer_id}</td>
                  <td>
                    <Link
                      to={{
                        pathname: "/pricing/pricing-info",
                        pricingInfo: item,
                      }}
                      style={{ color: "blue" }}
                    >
                      {`${item.customer_info.name}`}
                    </Link>
                  </td>
                  <td>{item.facility_info.tentative_loan_product}</td>
                  <td>{tenor}</td>
                  <td>{rate ? rate.toFixed(2) + "%" : "-"}</td>
                  <td>{"9%"}</td>
                  <td>{item.process_date}</td>
                  <td>{item.actor}</td>

                  <td className="text-right">
                    {true ? (
                      <a
                        rel="tooltip"
                        aria-disabled="true"
                        className="btn btn-info btn-simple btn-xs"
                        data-original-title="View Profile"
                      >
                        <i
                          onClick={() => {
                            this.onDelete(item);
                          }}
                          style={{ fontSize: 23, color: "red" }}
                          className="pe-7s-trash"
                        ></i>
                      </a>
                    ) : (
                      <div></div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Step 1 Modal: Select type + bank relationship */}
        <Modal
          show={this.state.openNew}
          onHide={() => this.setState({ openNew: false, bankType: "" })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Customer Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="customer-info-modal">
              <div className="step-section">
                <div className="step-title">
                  <span className="step-badge">1</span>
                  Customer Type
                </div>
                <div className="option-cards">
                  <div
                    className={`option-card ${this.state.type === "retail" ? "selected" : ""}`}
                    onClick={() =>
                      this.setState({ type: "retail", bankType: "" })
                    }
                  >
                    <div className="card-header">
                      <span className="card-label">Retail Customer</span>
                      <span className="card-check" />
                    </div>
                    <span className="card-desc">
                      Individual / personal banking
                    </span>
                  </div>
                  <div
                    className={`option-card ${this.state.type === "corporate" ? "selected" : ""}`}
                    onClick={() =>
                      this.setState({ type: "corporate", bankType: "" })
                    }
                  >
                    <div className="card-header">
                      <span className="card-label">Corporate Customer</span>
                      <span className="card-check" />
                    </div>
                    <span className="card-desc">
                      Business / corporate banking
                    </span>
                  </div>
                </div>
              </div>
              <div className="step-divider" />
              <div className="step-section">
                <div className="step-title">
                  <span className="step-badge">2</span>
                  Bank Relationship
                </div>
                <div className="option-cards">
                  <div
                    className={`option-card ${this.state.bankType === "existing" ? "selected" : ""}`}
                    onClick={() => this.setState({ bankType: "existing" })}
                  >
                    <div className="card-header">
                      <span className="card-label">Existing to Bank</span>
                      <span className="card-check" />
                    </div>
                    <span className="card-desc">Already a bank customer</span>
                  </div>
                  <div
                    className={`option-card ${this.state.bankType === "new" ? "selected" : ""}`}
                    onClick={() => this.setState({ bankType: "new" })}
                  >
                    <div className="card-header">
                      <span className="card-label">New to Bank</span>
                      <span className="card-check" />
                    </div>
                    <span className="card-desc">First-time bank customer</span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="buttons">
            <button
              className="btn-close"
              onClick={() => this.setState({ openNew: false, bankType: "" })}
            >
              CANCEL
            </button>
            <button
              disabled={!this.state.bankType}
              className="btn-next"
              onClick={() =>
                this.setState({
                  openNew: false,
                  openForm: true,
                  formData: {
                    collateral_currency: "VND",
                    tentative_loan_ccy: "VND",
                  },
                  customerSearch: "",
                  selectedCustomer: null,
                })
              }
            >
              NEXT
            </button>
          </Modal.Footer>
        </Modal>

        {/* Step 2 Modal: Fill in customer & facility info */}
        <Modal
          show={this.state.openForm}
          onHide={() => this.setState({ openForm: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Customer Information (
              {this.state.bankType === "new"
                ? "New to Bank"
                : "Existing to Bank"}
              )
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.bankType === "existing" ? (
              <div>
                <div className="form-group" style={{ position: "relative" }}>
                  <label style={{ fontWeight: 600, fontSize: 13 }}>
                    Search Customer (ID / Name)
                  </label>
                  <input
                    className="form-control"
                    placeholder="Search by ID or customer name..."
                    value={this.state.customerSearch || ""}
                    onChange={(e) =>
                      this.setState({
                        customerSearch: e.target.value,
                        selectedCustomer: null,
                        formData: {
                          collateral_currency: "VND",
                          tentative_loan_ccy: "VND",
                        },
                      })
                    }
                    autoComplete="off"
                  />
                  {this.state.customerSearch &&
                    !this.state.selectedCustomer && (
                      <div className="customer-search-dropdown">
                        {(this.state.items || [])
                          .filter(
                            (item) =>
                              (item.customer_id || "")
                                .toLowerCase()
                                .includes(
                                  this.state.customerSearch.toLowerCase(),
                                ) ||
                              ((item.customer_info || {}).name || "")
                                .toLowerCase()
                                .includes(
                                  this.state.customerSearch.toLowerCase(),
                                ),
                          )
                          .slice(0, 6)
                          .map((item) => (
                            <div
                              key={item.customer_id + "_" + item.process_date}
                              className="customer-search-item"
                              onClick={() => {
                                const info = item.customer_info || {};
                                this.setState({
                                  customerSearch:
                                    item.customer_id +
                                    " — " +
                                    (info.name || ""),
                                  selectedCustomer: item,
                                  formData: {
                                    ...this.state.formData,
                                    customer_id: item.customer_id,
                                    ...info,
                                  },
                                });
                              }}
                            >
                              <span className="search-cif">
                                {item.customer_id}
                              </span>
                              <span className="search-name">
                                {(item.customer_info || {}).name}
                              </span>
                            </div>
                          ))}
                        {(this.state.items || []).filter(
                          (item) =>
                            (item.customer_id || "")
                              .toLowerCase()
                              .includes(
                                this.state.customerSearch.toLowerCase(),
                              ) ||
                            ((item.customer_info || {}).name || "")
                              .toLowerCase()
                              .includes(
                                this.state.customerSearch.toLowerCase(),
                              ),
                        ).length === 0 && (
                          <div className="customer-search-empty">
                            No matching customers found
                          </div>
                        )}
                      </div>
                    )}
                </div>
                {this.state.selectedCustomer && (
                  <div className="existing-customer-card">
                    <div className="existing-customer-header">
                      <span className="existing-badge">
                        ✓ Existing Customer
                      </span>
                      <button
                        type="button"
                        className="change-customer-btn"
                        onClick={() =>
                          this.setState({
                            selectedCustomer: null,
                            customerSearch: "",
                            formData: {
                              collateral_currency: "VND",
                              tentative_loan_ccy: "VND",
                            },
                          })
                        }
                      >
                        Change
                      </button>
                    </div>
                    <div className="existing-customer-rows">
                      <div className="ecr-row">
                        <span className="ecr-label">ID</span>
                        <span className="ecr-value">
                          {this.state.selectedCustomer.customer_id}
                        </span>
                      </div>
                      <div className="ecr-row">
                        <span className="ecr-label">Name</span>
                        <span className="ecr-value">
                          {
                            (this.state.selectedCustomer.customer_info || {})
                              .name
                          }
                        </span>
                      </div>
                      {(this.state.selectedCustomer.customer_info || {})
                        .gender && (
                        <div className="ecr-row">
                          <span className="ecr-label">Gender</span>
                          <span className="ecr-value">
                            {
                              (this.state.selectedCustomer.customer_info || {})
                                .gender
                            }
                          </span>
                        </div>
                      )}
                      {(this.state.selectedCustomer.customer_info || {})
                        .date_of_birth && (
                        <div className="ecr-row">
                          <span className="ecr-label">Date of Birth</span>
                          <span className="ecr-value">
                            {
                              (this.state.selectedCustomer.customer_info || {})
                                .date_of_birth
                            }
                          </span>
                        </div>
                      )}
                      {(this.state.selectedCustomer.customer_info || {})
                        .historical_rating_latest_rating && (
                        <div className="ecr-row">
                          <span className="ecr-label">Latest Rating</span>
                          <span className="ecr-value">
                            {
                              (this.state.selectedCustomer.customer_info || {})
                                .historical_rating_latest_rating
                            }
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="form-group">
                <label style={{ fontWeight: 600, fontSize: 13 }}>ID</label>
                <input
                  className="form-control"
                  placeholder="ID"
                  value={this.state.formData.customer_id || ""}
                  onChange={(e) =>
                    this.setFormData("customer_id", e.target.value)
                  }
                />
              </div>
            )}

            {this.state.bankType === "new" && (
              <div>
                <div className="form-group">
                  <label style={{ fontWeight: 600, fontSize: 13 }}>
                    Customer Name
                  </label>
                  <input
                    className="form-control"
                    placeholder="Customer Name"
                    value={this.state.formData.customer_name || ""}
                    onChange={(e) =>
                      this.setFormData("customer_name", e.target.value)
                    }
                  />
                </div>
                <div className="form-group">
                  <label style={{ fontWeight: 600, fontSize: 13 }}>
                    Party Type
                  </label>
                  <select
                    className="form-control"
                    value={this.state.formData.party_type || ""}
                    onChange={(e) =>
                      this.setFormData("party_type", e.target.value)
                    }
                  >
                    <option value="">-- Select --</option>
                    {partyTypeOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label style={{ fontWeight: 600, fontSize: 13 }}>
                    Latest Report Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={this.state.formData.financial_statement_date || ""}
                    onChange={(e) =>
                      this.setFormData(
                        "financial_statement_date",
                        e.target.value,
                      )
                    }
                  />
                </div>
                <div className="form-group">
                  <label style={{ fontWeight: 600, fontSize: 13 }}>RWA</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="0"
                    value={fmtN(this.state.formData.rwa)}
                    onChange={(e) =>
                      this.setFormData("rwa", parseN(e.target.value))
                    }
                  />
                </div>
                <div className="form-group">
                  <label style={{ fontWeight: 600, fontSize: 13 }}>
                    Total Asset as of Latest Report Date
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="0"
                    value={fmtN(this.state.formData.total_assets)}
                    onChange={(e) =>
                      this.setFormData("total_assets", parseN(e.target.value))
                    }
                  />
                </div>
                <div className="form-group">
                  <label style={{ fontWeight: 600, fontSize: 13 }}>
                    Revenue as of Latest Report Date
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="0"
                    value={fmtN(this.state.formData.revenue)}
                    onChange={(e) =>
                      this.setFormData("revenue", parseN(e.target.value))
                    }
                  />
                </div>
                <div className="form-group">
                  <label style={{ fontWeight: 600, fontSize: 13 }}>
                    Rating as of Latest Report Date
                  </label>
                  <input
                    className="form-control"
                    placeholder="Rating"
                    value={
                      this.state.formData.historical_rating_latest_rating || ""
                    }
                    onChange={(e) =>
                      this.setFormData(
                        "historical_rating_latest_rating",
                        e.target.value,
                      )
                    }
                  />
                </div>
              </div>
            )}

            <div className="form-group">
              <label style={{ fontWeight: 600, fontSize: 13 }}>
                Tentative Loan Product
              </label>
              <select
                className="form-control"
                value={this.state.formData.tentative_loan_product_code || ""}
                onChange={(e) => {
                  const opt = this.state.productOptions.find(
                    (o) => o.value === e.target.value,
                  );
                  this.setState({
                    formData: {
                      ...this.state.formData,
                      tentative_loan_product_code: e.target.value,
                      tentative_loan_product: opt ? opt.label : "",
                    },
                  });
                }}
              >
                <option value="">-- Select --</option>
                {this.state.productOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label style={{ fontWeight: 600, fontSize: 13 }}>
                Tentative Loan Amount
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="0"
                value={fmtN(this.state.formData.tentative_loan_amount)}
                onChange={(e) =>
                  this.setFormData(
                    "tentative_loan_amount",
                    parseN(e.target.value),
                  )
                }
              />
            </div>
            <div className="form-group">
              <label style={{ fontWeight: 600, fontSize: 13 }}>
                Tentative Loan Currency
              </label>
              <select
                className="form-control"
                value={this.state.formData.tentative_loan_ccy || "VND"}
                onChange={(e) =>
                  this.setFormData("tentative_loan_ccy", e.target.value)
                }
              >
                <option value="VND">VND</option>
              </select>
            </div>
            <div className="form-group">
              <label style={{ fontWeight: 600, fontSize: 13 }}>
                Collateral Type
              </label>
              <select
                className="form-control"
                value={this.state.formData.collateral_type || ""}
                onChange={(e) => {
                  const opt = this.state.collateralTypeOptions.find(
                    (o) => o.value === e.target.value,
                  );
                  this.setState({
                    formData: {
                      ...this.state.formData,
                      collateral_type: e.target.value,
                      collateral_type_name: opt ? opt.label : "",
                    },
                  });
                }}
              >
                <option value="">-- Select --</option>
                {this.state.collateralTypeOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label style={{ fontWeight: 600, fontSize: 13 }}>
                Collateral Amount
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="0"
                value={fmtN(this.state.formData.collateral_value)}
                onChange={(e) =>
                  this.setFormData("collateral_value", parseN(e.target.value))
                }
              />
            </div>
            <div className="form-group">
              <label style={{ fontWeight: 600, fontSize: 13 }}>
                Collateral Currency
              </label>
              <select
                className="form-control"
                value={this.state.formData.collateral_currency || "VND"}
                onChange={(e) =>
                  this.setFormData("collateral_currency", e.target.value)
                }
              >
                <option value="VND">VND</option>
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer className="buttons">
            <button
              className="btn-close"
              onClick={() => this.setState({ openForm: false, openNew: true })}
            >
              BACK
            </button>
            <button
              disabled={
                this.state.bankType === "existing"
                  ? !this.state.selectedCustomer && !this.state.customerSearch
                  : !this.state.formData.customer_id
              }
              className="btn-next"
              onClick={() => {
                const finalFormData =
                  this.state.bankType === "existing" &&
                  !this.state.formData.customer_id &&
                  this.state.customerSearch
                    ? {
                        ...this.state.formData,
                        customer_id: this.state.customerSearch
                          .split(" — ")[0]
                          .trim(),
                      }
                    : this.state.formData;
                this.setState({ openForm: false });
                sessionStorage.setItem(
                  "pricingPrefillData",
                  JSON.stringify(finalFormData),
                );
                this.props.history.push(
                  `/pricing/new-processing?type=${this.state.type}&bankType=${this.state.bankType}`,
                  { prefillData: finalFormData },
                );
              }}
            >
              NEXT
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default withRouter(RetailTable);



// WEBPACK FOOTER //
// src/pages/Pricing/Processing/RetailTable.js